import { useMemo } from 'react';

import type { AdfoxContextData } from '../../types';
import { PParams } from '../../../../../types';

import { useSelector } from 'react-redux';
import { selectAdfoxPuids } from '../../../../../../../selectors/adfox/selectAdfoxPuids';

type Params = AdfoxContextData['params'];

export const PR_RANDOM = getRandomId();

export function getRandomId() {
  return String(Math.floor(Math.random() * 4294967295) + 1);
}

export function useAdfoxParams(pParams: PParams): Params {
  const puids = useSelector(selectAdfoxPuids);

  return useMemo((): Params => {
    return {
      pr: PR_RANDOM,
      ...puids,
      ...pParams,
    };
  }, [pParams, puids]);
}
